import {
  getGtmAppliedFilterValues,
  getGtmProductData,
  getGtmProductsData,
} from 'services/gtm/gtmData';
import { pushGtmEvent } from 'services/gtm/gtmEvents';
import {
  formatListingProduct,
  formatListingProducts,
} from 'services/gtm/inputDataFormatter';
import {
  GTM_ATTRIBUTES_BASE_PRODUCT,
  GTM_CATEGORY_LIST_PAGE,
  GTM_CATEGORY_LIST_PAGE_CLICK_OTHER,
  GTM_EVENT_CLICK_OTHER,
  GTM_EVENT_FILTER,
  GTM_CATEGORY_SEARCH_PAGE,
  GTM_EVENT_PRODUCT_CLICK,
  GTM_EVENT_PRODUCT_IMPRESSION,
  GTM_CATEGORY_SEARCH_PAGE_WITHOUT_RESULT,
} from 'settings/gtm/gtmEvent';
import {
  AppliedFilterType,
  ProductType,
} from 'types/ProductListing/ProductListing';

export function pushProductImpressionEvent(products: ProductType[]): void {
  pushGtmEvent({
    event: GTM_EVENT_PRODUCT_IMPRESSION,
    category: GTM_CATEGORY_LIST_PAGE,
    products: getGtmProductsData(
      formatListingProducts(products),
      GTM_ATTRIBUTES_BASE_PRODUCT
    ),
  });
}

export function pushProductClickEvent(
  product: ProductType,
  appliedFilters?: AppliedFilterType[]
): void {
  pushGtmEvent({
    event: GTM_EVENT_PRODUCT_CLICK,
    category: GTM_CATEGORY_LIST_PAGE,
    filter_value: getGtmAppliedFilterValues(appliedFilters ?? []),
    products: [
      getGtmProductData(
        formatListingProduct(product),
        GTM_ATTRIBUTES_BASE_PRODUCT
      ),
    ],
  });
}

export function pushPagerChangeEvent(detail: string): void {
  pushGtmEvent({
    event: GTM_EVENT_CLICK_OTHER,
    category: GTM_CATEGORY_LIST_PAGE_CLICK_OTHER,
    element: 'navigation des pages',
    detail: detail,
  });
}

export function convertTypeToDetail(input: string): string {
  let detail = input;

  switch (input) {
    case 'previous':
      detail = 'page précédente';
      break;
    case 'next':
      detail = 'page suivante';
      break;
  }

  return detail;
}

export function pushFilterChangeEvent(
  filterType: string,
  filterValue: string
): void {
  pushGtmEvent({
    event: GTM_EVENT_FILTER,
    page_filters: [
      {
        filter_type: filterType.toLowerCase(),
        filter_value: filterValue.toLowerCase(),
      },
    ],
  });
}

export function pushSearchProductImpressionEvent(
  products: ProductType[]
): void {
  pushGtmEvent({
    event: GTM_EVENT_PRODUCT_IMPRESSION,
    category: 'page de résultats de recherche avec résultat',
    products: getGtmProductsData(
      formatListingProducts(products),
      GTM_ATTRIBUTES_BASE_PRODUCT
    ),
  });
}

export function pushSearchProductClickEvent(product: ProductType): void {
  pushGtmEvent({
    event: GTM_EVENT_PRODUCT_CLICK,
    category: GTM_CATEGORY_SEARCH_PAGE,
    element: 'page de résultats de recherche avec résultat',
    products: [
      getGtmProductData(
        formatListingProduct(product),
        GTM_ATTRIBUTES_BASE_PRODUCT
      ),
    ],
  });
}

export function pushSearchProductWithoutResultImpressionEvent(): void {
  pushGtmEvent({
    event: GTM_EVENT_PRODUCT_IMPRESSION,
    category: GTM_CATEGORY_SEARCH_PAGE_WITHOUT_RESULT,
    products: [],
  });
}
